import { useDesktopZoomShortcuts } from '@/app-shell/desktop/hooks/useDesktopZoomShortcuts';

/** Headless desktop-only listener for browser-style UI zoom shortcuts. */
export const TauriZoomShortcuts = () => {
  useDesktopZoomShortcuts();
  return null;
};
